import React, { FC } from "react";
import type { ContentfulImageLinkGalleryType } from "@/types";
import { Link } from "./link";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "./image";

export const ImageLinkGallery: FC<ContentfulImageLinkGalleryType> = ({
  gallery,
}) => {
  return (
    <div className="imageLinkGallery">
      <Swiper
        modules={[A11y]}
        spaceBetween={8}
        slidesPerView={1.1}
        breakpoints={{
          1024: {
            slidesPerView: 1.4,
            spaceBetween: 56,
          },
        }}
        grabCursor
        className="imageLinkGallery--swiper"
      >
        {gallery.map((slide, index) => {
          return (
            <SwiperSlide key={index} className="imageLinkGallery--slide">
              {slide.link ? (
                <Link
                  noStyle
                  href={slide.link}
                  className="imageLinkGallery--slide-link"
                >
                  <Image
                    src={slide.file}
                    alt={slide.file.fields.title as string}
                    className={`imageLinkGallery--slide-image A${slide.aspect}`}
                  />
                  {slide.showTitle && slide.file.fields.title && (
                    <div className="imageLinkGallery--slide-title">
                      {slide.file.fields.title as string}
                    </div>
                  )}
                </Link>
              ) : (
                <div className="imageLinkGallery--slide-link">
                  <Image
                    src={slide.file}
                    alt={slide.file.fields.title as string}
                    className={`imageLinkGallery--slide-image A${slide.aspect}`}
                  />
                  {slide.showTitle && slide.file.fields.title && (
                    <div className="imageLinkGallery--slide-title">
                      {slide.file.fields.title as string}
                    </div>
                  )}
                </div>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
